import { FC } from 'react'

import {
  getFileExtensionByPath,
  IMAGE_EXTENSIONS,
  PDF_EXTENSION,
  SHEET_EXTENSIONS,
  VIDEO_EXTENSIONS,
  WORD_EXTENSIONS
} from '@/utils/file'

import DownloadFileError from '../assets/DownloadFileError.svg'
import DownloadFileExcel from '../assets/DownloadFileExcel.svg'
import DownloadFileImage from '../assets/DownloadFileImage.svg'
import DownloadFilePdf from '../assets/DownloadFilePdf.svg'
import DownloadFileSuccess from '../assets/DownloadFileSuccess.svg'
import DownloadFileVideo from '../assets/DownloadFileVideo.svg'
import DownloadFileWord from '../assets/DownloadFileWord.svg'

type Props = {
  fileName?: string
  error?: boolean
}

export const DownloadedFileIcon: FC<Props> = ({ fileName = '', error }) => {
  const fileExtension = getFileExtensionByPath(fileName)

  if (error) {
    return <DownloadFileError />
  }
  if (IMAGE_EXTENSIONS.includes(`.${fileExtension}`)) {
    return <DownloadFileImage />
  }
  if (VIDEO_EXTENSIONS.includes(`.${fileExtension}`)) {
    return <DownloadFileVideo />
  }
  if (PDF_EXTENSION.includes(`.${fileExtension}`)) {
    return <DownloadFilePdf />
  }
  if (SHEET_EXTENSIONS.includes(`.${fileExtension}`)) {
    return <DownloadFileExcel />
  }
  if (WORD_EXTENSIONS.includes(`.${fileExtension}`)) {
    return <DownloadFileWord />
  }

  return <DownloadFileSuccess />
}
